export const cartTypes = {
  DISPLAY_CART: "DISPLAY_CART",
  ADD_TO_CART: "ADD_TO_CART",
  REMOVE_FROM_CART: "REMOVE_FROM_CART",
  UPDATE_QUANTITY_IN_CART: "UPDATE_QUANTITY_IN_CART",
};
